var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0372 17.9674C11.4142 18.3552 11.4197 18.9783 11.0436 19.3651C10.67 19.7492 10.0691 19.754 9.68689 19.361L3.67553 13.1794C3.29979 12.793 3.29332 12.1732 3.67553 11.7802L9.68689 5.59863C10.0626 5.21225 10.6674 5.20775 11.0436 5.59455C11.4171 5.97868 11.4184 6.60014 11.0372 6.99219L6.65718 11.4962H19.6498C20.1795 11.4962 20.6088 11.9328 20.6088 12.4798C20.6088 13.023 20.176 13.4634 19.6498 13.4634H6.65718L11.0372 17.9674Z",
    fill: "#333333"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_367_734",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 5,
    width: 18,
    height: 15
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0372 17.9674C11.4142 18.3552 11.4197 18.9783 11.0436 19.3651C10.67 19.7492 10.0691 19.754 9.68689 19.361L3.67553 13.1794C3.29979 12.793 3.29332 12.1732 3.67553 11.7802L9.68689 5.59863C10.0626 5.21225 10.6674 5.20775 11.0436 5.59455C11.4171 5.97868 11.4184 6.60014 11.0372 6.99219L6.65718 11.4962H19.6498C20.1795 11.4962 20.6088 11.9328 20.6088 12.4798C20.6088 13.023 20.176 13.4634 19.6498 13.4634H6.65718L11.0372 17.9674Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_367_734)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.99685a202075b2a562b36fc2523b7fc4.svg";
export { ForwardRef as ReactComponent };